import hcl from "refractor/hcl";
export default hcl;